var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"currencyNotAvailable"},[_vm._v(" Moeda não disponivel ")])
}
var staticRenderFns = []

export { render, staticRenderFns }